import React from 'react';

import { InviteStatus } from '@ndvr/auth-api';

import { InviteButton } from 'modules';
import { PERSON_STATUS_TAG_MAP, titleCase, useRequiredParams } from 'utils';
import { ButtonWithConfirmModal, DataGrid, ModalText, PageSpinner, Tag, Title, VerticalLayout } from 'widgets';

import {
    useCognitoDetails,
    useInviteDetails,
    usePersonCredential,
    usePersonOrgProfile,
    useToggleUserCredential,
} from '../person-queries';

export const LoginStatus = () => {
    const { personOrgGUID } = useRequiredParams(['personOrgGUID']);

    const { data: person, isLoading } = usePersonOrgProfile(personOrgGUID);
    const { data: inviteDetails, isPending: inviteDetailsLoading } = useInviteDetails(personOrgGUID);
    const { data: credential } = usePersonCredential(personOrgGUID);
    const { data: cognitoDetails } = useCognitoDetails(personOrgGUID);
    const toggleUserCredentialMutation = useToggleUserCredential(personOrgGUID);

    if (isLoading || inviteDetailsLoading) {
        return <PageSpinner />;
    }

    if (!person || !inviteDetails) {
        return null;
    }

    return (
        <VerticalLayout $gap={32}>
            <Title content>Login</Title>
            <VerticalLayout $gap={16} $columnStart>
                <DataGrid
                    values={[
                        { label: 'Cognito login email', value: cognitoDetails?.email || 'not found' },
                        { label: 'Cognito identifier', value: cognitoDetails?.credentialGUID || 'not found' },
                        {
                            label: 'Current status',
                            value: credential?.disabled ? (
                                <Tag type="negative">DISABLED</Tag>
                            ) : (
                                <Tag type={PERSON_STATUS_TAG_MAP[inviteDetails.inviteStatus]}>
                                    {titleCase(inviteDetails.inviteStatus)}
                                </Tag>
                            ),
                        },
                    ]}
                />
                {inviteDetails.inviteStatus === InviteStatus.REGISTERED ? (
                    <ButtonWithConfirmModal
                        buttonProps={{
                            buttonType: credential?.disabled ? 'primary' : 'destructive',
                            children: `${credential?.disabled ? 'Enable' : 'Disable'} log in`,
                            waiting: toggleUserCredentialMutation.isPending,
                        }}
                        onConfirm={() => toggleUserCredentialMutation.mutate(!credential?.disabled)}
                        modalTitle={`${credential?.disabled ? 'Enable' : 'Disable'} log in`}
                    >
                        <ModalText>
                            Are you sure you want to {credential?.disabled ? 'enable' : 'disable'} log in for user?
                        </ModalText>
                    </ButtonWithConfirmModal>
                ) : (
                    <InviteButton personOrgProfile={person} inviteDetails={inviteDetails} />
                )}
            </VerticalLayout>
        </VerticalLayout>
    );
};
